import { HttpContextToken, HttpErrorResponse, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service'; // ajusta la ruta
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { EMPTY, firstValueFrom, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NgZone } from '@angular/core';
import { UsuarioAuth } from '../../models/usuario.model';

// Permite saltarse el interceptor puntualmente
export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);
export const REQUIRES_ADMIN = new HttpContextToken<boolean>(() => false);


// const API_PREFIXES = [
//     environment.SERVER_USU_URL,
//     environment.SERVER_ART_URL,
//     environment.SERVER_PED_URL,
//     environment.SERVER_CLI_URL,
//     environment.SERVER_EAN_URL,
//     environment.SERVER_PORTAL_URL,
// ].filter(Boolean);

// 2) Endpoints a los que NO añadir Authorization (OAuth, reports, etc.)
// const BYPASS_PREFIXES = [
//     // environment.REPORT_SERVER_URL, // deprecated
//     // environment.OAUTH_URL_PHP, // deprecated
//     // environment.OAUTH_URL_ORDS, // deprecated
//     environment.OAUTH_URL_GMAUTH_ADMIN,
//     environment.OAUTH_URL_GMAUTH,
// ].filter(Boolean);

// 3) Endpoints que consideramos “validación de token” (ajusta a los tuyos reales)
// const TOKEN_CHECK_PATHS = [
//     environment.SERVER_USU_URL,
//     environment.SERVER_ART_URL,
//     environment.SERVER_PED_URL,
//     environment.SERVER_CLI_URL,
//     environment.SERVER_EAN_URL,
//     environment.SERVER_PORTAL_URL,
// ].filter(Boolean);

// const TOKEN_PATH_ADM = [
//     environment.SERVER_ADM_URL,
// ].filter(Boolean);

function startsWithAny(url: string, list: string[]) {
    return list.some(prefix => !!prefix && url.startsWith(prefix));
}
function isApi(url: string) {
    var API_PREFIXES = [
        environment.SERVER_USU_URL,
        environment.SERVER_ART_URL,
        environment.SERVER_PED_URL,
        environment.SERVER_CLI_URL,
        environment.SERVER_EAN_URL,
        environment.SERVER_PORTAL_URL,
    ].filter(Boolean);
    return API_PREFIXES.some(p => url.includes(p))
    // return startsWithAny(url, API_PREFIXES);
}
function shouldBypass(url: string) {
    var BYPASS_PREFIXES = [
        // environment.REPORT_SERVER_URL, // deprecated
        // environment.OAUTH_URL_PHP, // deprecated
        // environment.OAUTH_URL_ORDS, // deprecated
        environment.OAUTH_URL_GMAUTH_ADMIN,
        environment.OAUTH_URL_GMAUTH,
    ].filter(Boolean);
    return startsWithAny(url, BYPASS_PREFIXES);
}
function isTokenValidation(url: string) {
    var TOKEN_CHECK_PATHS = [
        environment.SERVER_USU_URL,
        environment.SERVER_ART_URL,
        environment.SERVER_PED_URL,
        environment.SERVER_CLI_URL,
        environment.SERVER_EAN_URL,
        environment.SERVER_PORTAL_URL,
    ].filter(Boolean);
    return TOKEN_CHECK_PATHS.some(p => url.includes(p));
}
function isTokenAdmValidation(url: string) {
    var TOKEN_PATH_ADM = [
        environment.SERVER_ADM_URL,
    ].filter(Boolean)
    return startsWithAny(url, TOKEN_PATH_ADM);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const bypass = req.context.get(BYPASS_AUTH);
    const auth = inject(AuthService);
    const router = inject(Router);

    if (bypass || shouldBypass(req.url)) {
        console.log("\n\tSIN TOKEN EN :" + req.url);
        return next(req);
    }

    const alreadyHasAuth = !!req.headers.get('Authorization');
    const isApiReq = isApi(req.url);
    const needsAdmin = isTokenAdmValidation(req.url) && !alreadyHasAuth;

    const userToken = auth.getToken();

    // Caso especial: esta petición necesita token ADMIN -> esperamos a obtenerlo
    if (needsAdmin) {
        return auth.getTokenApp(
            environment.ADMIN_ID,
            environment.PASSWORD_ADMIN,
            environment.USERNAME_ADMIN
        ).pipe(
            map(res => res.access_token),
            switchMap((tokenAdm) => {
                const adminReq = tokenAdm
                    ? req.clone({ setHeaders: { Authorization: `Bearer ${tokenAdm}` } })
                    : req; // si por lo que sea no hay token, seguimos sin modificar
                console.log("\n\tMETE TOKEN ADM EN : " + adminReq.url);
                return next(adminReq);
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 418) {
                    auth.messageCambioClave = err.error;
                    router.navigate(['login']);

                    return throwError(() => err);

                }
                return throwError(() => err);

            })
        );
    }

    // Resto de peticiones: si es de tus APIs y no trae Authorization, añade el token de usuario
    let request = req;
    if (userToken && isApiReq && !alreadyHasAuth) {
        console.log("\n\tMETE TOKEN EN : " + req.url);
        request = req.clone({
            setHeaders: { Authorization: `Bearer ${userToken}` }
        });
    }

    // Cadena normal + lógica de refresh
    return next(request).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err.status === 418) {
                //console.warn("TEAPOT SIUUUUUUUUUUUUUUUUUUUUUUUUUUUUU");
                return EMPTY;
            }
            if (err.status === 401 && isTokenValidation(req.url) && auth.getRefreshToken()) {
                // limpia solo el access; deja el refresh
                localStorage.removeItem('ACCESS_TOKEN');
                localStorage.removeItem('ACCESS_TOKEN_EXPIRE');
                localStorage.removeItem('ACCESS_TOKEN_TYPE');
                localStorage.removeItem('ACCESS_TOKEN_DATE');

                return auth.renuevaToken(
                    environment.CLIENT_SECRET,
                    environment.CLIENT_ID,
                    auth.getRefreshToken()
                ).pipe(
                    tap((res: UsuarioAuth) => {
                        localStorage.setItem('ACCESS_TOKEN', res.access_token);
                        localStorage.setItem('ACCESS_TOKEN_EXPIRE', String(res.expires_in));
                        localStorage.setItem('REFRESH_TOKEN', res.refresh_token);
                        localStorage.setItem('REFRESH_TOKEN_EXPIRE', String(res.refresh_expires_in));
                        localStorage.setItem('ACCESS_TOKEN_TYPE', res.token_type);
                        localStorage.setItem('ACCESS_TOKEN_DATE', String(Date.now()));
                    }),
                    switchMap((res: UsuarioAuth) => {
                        const retried = req.clone({
                            setHeaders: { Authorization: `Bearer ${res.access_token}` }
                        });
                        return next(retried);
                    }),
                    catchError((refreshErr: HttpErrorResponse) => {
                        console.log('REFRESH FALLÓ:', refreshErr.status);
                        if (refreshErr.status === 401 || refreshErr.status === 400) {
                            auth.logout();
                            router.navigate(['login']);
                            return EMPTY;
                        }
                        return throwError(() => refreshErr);
                    })
                );
            }

            return throwError(() => err);
        })
    );
};